import { useEffect, useRef } from 'react';

const useDepsInterval = (callback, ms = 1000, deps = [], callbackOnChange = () => {}) => {
  const interval = useRef();

  const callbackRef = useRef(callback);

  const diff = useRef(JSON.stringify(deps));

  useEffect(() => {
    interval.current = setInterval(() => {
      if (callbackRef.current) {
        callbackRef.current();
        callbackRef.current = undefined;
      }
    }, ms);

    return () => {
      clearInterval(interval.current);
    };
  }, [ms]);

  useEffect(() => {
    const depsAsString = JSON.stringify(deps);
    if (deps.length === 0 || diff.current !== depsAsString) {
      callbackOnChange();
      callbackRef.current = callback;
      diff.current = depsAsString;
    }
  }, [callback, callbackOnChange, ...deps]);
};

export default useDepsInterval;
